import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {GlobalLoader} from '../GlobalLoader';
import {Subtitle} from '../ui/Subtitle/Subtitle';
import {Title} from '../ui/Title';
import {IOuter} from './PaymentProcessing.types';

export const PaymentProcessing: React.FunctionComponent<IOuter> = () => {
  const {t} = useTranslation();

  return (
    <div>
      <Title>{t('mgw.processingPaymentMessageTitle')}</Title>
      <Subtitle>{t('mgw.processingPaymentMessageSubtitle')}</Subtitle>
      <GlobalLoader />
    </div>
  );
};

PaymentProcessing.displayName = 'PaymentProcessing';
